module.exports = __webpack_public_path__ + "img/TX.78d5d1ed.svg";